<div
  class="card-form-group-container"
  [formGroup]="form">
  <app-input-vocabulary-autocomplete
    formControlName="CDGG"
    [vocabularyName]="'V_CDGG'"
    [placeholder]="'Indicazione generica (CDGG)'">
  </app-input-vocabulary-autocomplete>
  <mat-form-field>
    <input
      matInput
      placeholder="Indicazione specifica (CDGS)"
      formControlName="CDGS">
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      placeholder="Indirizzo (CDGI)"
      formControlName="CDGI">
  </mat-form-field>
</div>
